import { useState, useCallback } from 'react';

export const useDrag = ({ onSetDragInfo, boardHeight }) => {
  const [, setLocalDragInfo] = useState(null);

  const handleMouseDownDrag = useCallback(
    (e, id) => {
      const initialDragInfo = {
        startX: e.pageX,
        startY: e.pageY,
        x: 0,
        y: 0,
        id,
      };
      onSetDragInfo(initialDragInfo);
      setLocalDragInfo(initialDragInfo);

      const handleMouseMove = (e) => {
        setLocalDragInfo((prevState) => {
          const nextState = {
            ...prevState,
            x: e.pageX - prevState.startX,
            y: e.pageY - prevState.startY,
          };
          onSetDragInfo(nextState);
          return nextState;
        });

        const cursorRationScreenX = e.y / window.innerHeight;

        if (cursorRationScreenX < 0.15) {
          window.document.scrollingElement.scrollTop -= 20;
        }

        if (cursorRationScreenX > 0.85) {
          window.document.scrollingElement.scrollTop = Math.min(
            window.document.scrollingElement.scrollTop + 20,
            boardHeight - window.innerHeight / 2
          );
        }
      };

      const handleContextMenu = (e) => {
        e.preventDefault();
      };

      const handleMouseUp = () => {
        onSetDragInfo(null);
        setLocalDragInfo(null);
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        window.removeEventListener('contextmenu', handleContextMenu);
      };

      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('contextmenu', handleContextMenu);
    },
    [onSetDragInfo, boardHeight]
  );

  return {
    handleMouseDownDrag,
  };
};
